import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const fileArrangementTemplate = htmlE`
  <style>
    .arrangement-card {
      box-shadow: 0px 0px 3px var(--accent-color);
      text-transform: capitalize;
      transition: transform 0.1s linear;
      width: 200px;
      cursor: all-scroll;
    }

    .arrangement-card.dragged-on {
      transform: scale(0.95);
    }

    .arrangement-card-dragging {
      opacity: 0.7;
    }
  </style>

  <div id="listingTableArrangement" class="h-full">
    <div
      class="w-full is-flex is-justify-content-center h-full is-align-items-center">
      <div
        class="table-column-arrangement is-flex is-flex-direction-column gap-3"></div>
    </div>
  </div>
`;

export const arrangementCardTemplate = htmlE`
  <div
    data-transfer-value="${"transfer_value"}"
    class="arrangement-card p-2 is-flex is-justify-content-space-between">
    <span data-i18n-key="${"i18n_key"}">${"label"}</span>
    <i class="icon-sort text-accentMain"></i>
  </div>
`;

export default fileArrangementTemplate;
